import React from "react";
import { get } from "lodash";

const ExcelDocumentComponent = ({ getBooksVocab, vocType }) => {
    const handleDownload = async () => {
        try {
            const { saveAs } = await import('file-saver');
            const ExcelJS = (await import('exceljs')).default;
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Vocabulary List');

            worksheet.pageSetup = {
                orientation: 'landscape',
                fitToPage: true,
                fitToWidth: 1,
                fitToHeight: 0
            };

            const headerStyle = {
                font: { bold: true, color: { argb: 'FFFFFFFF' }, size: 14 },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF5D4187' } },
                alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
                border: {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                }
            };

            const dataStyle = {
                font: { size: 12 },
                alignment: { vertical: 'top', horizontal: 'left', wrapText: true },
                border: {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                }
            };

            if (vocType) {
                worksheet.columns = [
                    { header: 'Word', key: 'word', width: 15 },
                    { header: 'Translation', key: 'translation', width: 15 },
                    { header: 'Definition', key: 'definition', width: 30 },
                    { header: 'Synonyms in Spanish', key: 'synonyms_spanish', width: 20 },
                    { header: 'Synonyms in English', key: 'synonyms_english', width: 20 },
                    { header: 'Antonyms in Spanish', key: 'antonyms_spanish', width: 20 },
                    { header: 'Antonyms in English', key: 'antonyms_english', width: 20 },
                    { header: 'Sentence in Spanish', key: 'sentence_spanish', width: 25 },
                    { header: 'Sentence in English', key: 'sentence_english', width: 25 }
                ];
            } else {
                worksheet.columns = [
                    { header: 'Word', key: 'word', width: 15 },
                    { header: 'Translation', key: 'translation', width: 15 },
                    { header: 'Definition', key: 'definition', width: 30 },
                    { header: 'Synonyms', key: 'synonyms', width: 25 },
                    { header: 'Antonyms', key: 'antonyms', width: 25 },
                    { header: 'Sentence', key: 'sentence', width: 30 }
                ];
            }

            worksheet.getRow(1).eachCell((cell) => {
                cell.style = headerStyle;
                cell.height = 30;
            });

            getBooksVocab.forEach((value, index) => {
                const data = get(value, 'data', '');
                const rowData = {};

                if (vocType) {
                    rowData.word = get(data, 'word') || '-';
                    rowData.translation = get(data, 'english_translation') || '-';
                    rowData.definition = get(data, 'definition') || '-';
                    rowData.synonyms_spanish = get(data, 'synonyms_in_spanish') || '-';
                    rowData.synonyms_english = get(data, 'synonyms_in_english') || '-';
                    rowData.antonyms_spanish = get(data, 'antonyms_in_spanish') || '-';
                    rowData.antonyms_english = get(data, 'antonyms_in_english') || '-';
                    rowData.sentence_spanish = get(data, 'sentence_in_spanish') || '-';
                    rowData.sentence_english = get(data, 'sentence_in_english') || '-';
                } else {
                    rowData.word = get(data, 'word') || '-';
                    rowData.translation = get(data, 'english_translation') || '-';
                    rowData.definition = get(data, 'definition') || '-';
                    rowData.synonyms = Array.isArray(get(data, 'synonyms')) ? get(data, 'synonyms').join(', ') : '-';
                    rowData.antonyms = Array.isArray(get(data, 'antonyms')) ? get(data, 'antonyms').join(', ') : '-';
                    rowData.sentence = get(data, 'sentence') || '-';
                }

                const row = worksheet.addRow(rowData);
                row.height = 40;
                
                row.eachCell((cell) => {
                    cell.style = dataStyle;
                    const bgColor = index % 2 === 0 ? 'FFFFFFFF' : 'FFF9F9F9';
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: bgColor }
                    };
                });
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, 'Vocabulary_List.xlsx');

        } catch (error) {
            console.error('Error creating Excel file:', error);
        }
    };

    return (
        <div>
            <button onClick={handleDownload} style={{ display: 'none' }}>
                Download Excel
            </button>
        </div>
    );
};

const ExcelDocumentCognatesComponent = ({ getBooksVocab, vocType }) => {
    const handleDownload = async () => {
        try {
            const { saveAs } = await import('file-saver');
            const ExcelJS = (await import('exceljs')).default;
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Cognates List');

            worksheet.pageSetup = {
                orientation: 'landscape',
                fitToPage: true,
                fitToWidth: 1,
                fitToHeight: 0
            };

            const headerStyle = {
                font: { bold: true, color: { argb: 'FFFFFFFF' }, size: 14 },
                fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF5D4187' } },
                alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
                border: {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                }
            };

            const dataStyle = {
                font: { size: 12 },
                alignment: { vertical: 'top', horizontal: 'left', wrapText: true },
                border: {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                }
            };

            worksheet.columns = [
                { header: 'Cognate', key: 'cognate', width: 10 },
                { header: 'Word (Spanish)', key: 'word_spanish', width: 15 },
                { header: 'Word (English)', key: 'word_english', width: 15 },
                { header: 'Type', key: 'type', width: 15 },
                { header: 'Explanation', key: 'explanation', width: 35 },
                { header: 'Sentence in Spanish', key: 'sentence_spanish', width: 25 },
                { header: 'Sentence in English', key: 'sentence_english', width: 25 }
            ];

            worksheet.getRow(1).eachCell((cell) => {
                cell.style = headerStyle;
                cell.height = 30;
            });

            getBooksVocab.forEach((value, index) => {
                const data = get(value, 'data', '');
                
                const rowData = {
                    cognate: data?.type ? "✓" : "✗",
                    word_spanish: get(data, "word_spanish") || "-",
                    word_english: get(data, "word_english") || "-",
                    type: data?.type ? "True Cognate" : "False Cognate",
                    explanation: get(data, "explaination") || "-",
                    sentence_spanish: get(data, "sentence_spanish") || "-",
                    sentence_english: get(data, "sentence_english") || "-"
                };

                const row = worksheet.addRow(rowData);
                row.height = 40;
                
                row.eachCell((cell) => {
                    cell.style = dataStyle;
                    const bgColor = index % 2 === 0 ? 'FFFFFFFF' : 'FFF9F9F9';
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: bgColor }
                    };
                });
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, 'Cognates_List.xlsx');

        } catch (error) {
            console.error('Error creating Excel file:', error);
        }
    };

    return (
        <div>
            <button onClick={handleDownload} style={{ display: 'none' }}>
                Download Excel
            </button>
        </div>
    );
};

export { ExcelDocumentComponent, ExcelDocumentCognatesComponent };

